import { render, staticRenderFns } from "./AssetClassification.vue?vue&type=template&id=eb518af4"
import script from "./AssetClassification.vue?vue&type=script&lang=js"
export * from "./AssetClassification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports